export const motpMessages = {
  NICE_UNAVAILABLE: '현재 승인된 휴대폰·아이핀 인증을 사용할 수 없습니다. 교육 운영 담당자에게 문의해 주세요.',
  NICE_PROFILE_REQUIRED: '회원정보에 생년월일이 없어 휴대폰·아이핀 인증을 진행할 수 없습니다. 고객센터로 문의해 주세요.',
  NICE_MEMBER_MISMATCH: '본인인증은 되었으나 등록된 회원정보와 일치하지 않습니다. 문제가 있는 경우 고객센터로 연락해 주시기 바랍니다.',
  NICE_PROVIDER_UNAVAILABLE: '본인인증 기관과 연결하지 못했습니다. 잠시 후 다시 시도해 주세요.',
  NICE_REQUEST_EXPIRED: '본인인증 요청이 만료되었거나 설정이 변경되었습니다. 새 인증 요청으로 다시 시도해 주세요.',
  NICE_REQUEST_BUSY: '본인인증 결과를 처리하고 있습니다. 잠시 후 다시 확인해 주세요.',
  MOTP_UNAVAILABLE: '현재 제공 가능한 인증 수단이 없습니다. 교육 운영 담당자에게 문의해 주세요.',
  MOTP_PROFILE_REQUIRED: '회원정보의 이름과 휴대폰 번호를 확인해 주세요. mOTP 앱의 등록 정보와 같아야 합니다.',
  MOTP_INPUT_INVALID: 'mOTP 인증번호 6자리를 확인해 주세요.',
  MOTP_ITEM_REQUIRED: '인증할 학습 차시를 먼저 선택해 주세요.',
  MOTP_REQUEST_EXPIRED: '인증 요청이 만료되었습니다. 새 인증번호로 다시 인증해 주세요.',
  MOTP_CONTEXT_CHANGED: '수강 또는 회원정보가 변경되었습니다. 현재 정보를 확인한 뒤 다시 인증해 주세요.',
  MOTP_REQUEST_BUSY: '인증 요청을 이미 처리하고 있습니다. 잠시 후 동일 요청으로 결과를 확인해 주세요.',
  MOTP_RATE_LIMITED: '인증 요청이 많습니다. 잠시 후 다시 시도해 주세요.',
  MOTP_AP001: 'OTP 번호를 확인해 주세요.',
  MOTP_AP005: '등록되지 않은 사용자입니다. mOTP 앱 등록 정보(이름·휴대폰 번호)가 회원정보와 같은지 확인하거나 1544-9335 고객센터로 문의해 주세요.',
  MOTP_AP009: 'OTP 5회 이상 틀림으로 계정 잠금 상태입니다. 아래 휴대폰·아이핀 본인인증으로 진행해 주세요(인증하면 잠금도 해제됩니다).',
  MOTP_IE001: 'HRD 서버 오류가 발생했습니다. 아래 휴대폰·아이핀 본인인증으로 대체해 주세요.',
  MOTP_CE001: 'HRD 서버 오류가 발생했습니다. 아래 휴대폰·아이핀 본인인증으로 대체해 주세요.',
  MOTP_CE002: 'HRD 서버 오류가 발생했습니다. 아래 휴대폰·아이핀 본인인증으로 대체해 주세요.',
  MOTP_CE003: 'HRD 서버 오류가 발생했습니다. 아래 휴대폰·아이핀 본인인증으로 대체해 주세요.',
  MOTP_PROVIDER_ERROR: '본인인증 결과를 확인하지 못했습니다. 잠시 후 다시 시도해 주세요.',
  MOTP_TIMEOUT: '본인인증 응답 시간이 초과되었습니다. 새 인증번호로 다시 인증해 주세요.',
  MOTP_UNKNOWN: '본인인증 처리 결과를 확인하지 못했습니다. 새 인증번호로 다시 인증해 주세요.',
  MOTP_LOCAL_COMMIT_FAILED: '본인인증 결과 저장을 확인하지 못했습니다. 교육 운영 담당자에게 문의해 주세요.',
}
